import { useState } from 'react'
import { redirectToLogin } from '../services/auth'
import Loader from '../components/Loader'

const Login = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState('')

	const handleLogin = async () => {
		setIsLoading(true)
		setError('')

		try {
			await redirectToLogin()
		} catch (err) {
			setError(err.message || 'Falha ao iniciar o login')
			setIsLoading(false)
		}
	}

	return (
		<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4 sm:px-6 lg:px-8">
			<div className="max-w-md w-full space-y-8 text-center">
				<div>
					<h2 className="text-4xl font-bold text-gray-900 mb-2">KSI Pay</h2>
					<p className="text-lg text-gray-600">Painel administrativo</p>
				</div>

				{error && (
					<div className="rounded-md bg-red-50 p-4">
						<div className="text-sm text-red-700">{error}</div>
					</div>
				)}

				<button
					type="button"
					onClick={handleLogin}
					disabled={isLoading}
					className="w-full py-4 px-6 text-lg font-semibold text-white bg-gradient-to-r from-primary-600 to-primary-700 rounded-xl hover:from-primary-700 hover:to-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-lg hover:shadow-xl"
				>
					{isLoading ? (
						<div className="flex items-center justify-center">
							<Loader size="sm" />
							<span className="ml-2">Redirecionando...</span>
						</div>
					) : (
						'Entrar'
					)}
				</button>
			</div>
		</div>
	)
}

export default Login
